import { useEffect } from "react";
import useMenuHeight from "@/components/hooks/use-menu-height/use-menu-height";
import useOpenDropdown from "@/components/hooks/use-open-dropdown/use-open-dropdown";
import useDropdownDirection from "@/components/hooks/use-dropdown-direction/use-dropdown-direction";
import type {
  DropdownDirection,
  MenuItem,
} from "@/components/ui/dropdowns/OpticksDropdown.types";

interface UseDropdownSingleOptionProps {
  direction?: DropdownDirection;
  menuItemsLength: number;
  focusProp?: () => void;
  handleChosenOptionChange?: Function;
}

const useDropdownSingleOption = ({
  direction = "down",
  menuItemsLength,
  focusProp,
  handleChosenOptionChange,
}: UseDropdownSingleOptionProps) => {
  // Open-Close handling
  const { open, setOpen, handleOpen } = useOpenDropdown();
  const handleClickOutside = () => {
    setOpen(false);
  };

  const handleOpenLocal = (e: React.BaseSyntheticEvent) => {
    handleOpen(e);
    focusProp && focusProp();
  };

  // Menu Height handling
  const { menuHeight, setMenuHeight, menuRef } = useMenuHeight();

  useEffect(() => {
    if (menuRef.current) {
      setMenuHeight(`${menuRef.current.scrollHeight}px`);
    }
  }, [open, menuRef, setMenuHeight, menuItemsLength]);

  // Dropdown Direction handling
  const { direction: computedDirection, containerRef } = useDropdownDirection({
    open,
    initialDirection: direction,
    menuHeight,
  });

  // Selected option handling (UI only, Form values via props)
  const handleChosenOption = (
    e: React.BaseSyntheticEvent,
    newChosenMenuItem: MenuItem
  ) => {
    handleChosenOptionChange && handleChosenOptionChange(newChosenMenuItem);
    handleOpen(e);
  };

  return {
    open,
    setOpen,
    handleOpenLocal,
    handleClickOutside,
    handleChosenOption,
    menuHeight,
    menuRef,
    computedDirection,
    containerRef,
  };
};

export default useDropdownSingleOption;
